module.exports = __webpack_public_path__ + "static/img/project-3d-printer.e90f417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-3d-printer.jpg
// module id = Lloc
// module chunks = 0